<template>
  <PageSection disable-sticky-margin :title="eventTitleFormated">
    <template #header>
      <div class="flex flex-row items-center gap-2">
        <span
          class="h-2 w-2 shrink-0 self-center rounded-full"
          :class="buttletClass"
        >
          &nbsp;
        </span>
        <h2
          class="text-xl font-medium text-gray-900 capitalize-first dark:text-white"
        >
          {{ eventTitleFormated }}
        </h2>
        <BaseDeleteButton
          v-if="editionMode && isDeletable"
          small
          :tooltip="$t('button.delete_v', { var: $t('global.event') })"
          @click="emitToDelete"
        />
      </div>
    </template>

    <formEvent
      :errors="errors"
      :props_event="propsEvent"
      :filtered-assets="filteredAssets"
      :get-input-value="getInputValue"
      :after-work-selected="afterWorkSelected"
      :index="index"
      :metadata="metadata.events"
      :edition-mode="editionMode"
    />
  </PageSection>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

import FormEvent from '../../../../components/Event/FormEvent'

export default {
  name: 'WorkEvent',
  emits: ['eventDeleteButtonPressed'],
  components: {
    FormEvent
  },
  props: {
    metadata: { type: Object, required: true },
    errors: { type: Object, required: true },
    index: { type: Number, required: true },
    isDeletable: { type: Boolean, required: false, default: true },
    workSelectable: { type: Boolean, required: false, default: true },
    editionMode: { type: Boolean, required: true },
    propsEvent: { type: Object, required: false, default: null }
  },
  computed: {
    buttletClass() {
      return 'bg-theme-' + this.propsEvent?.type
    },
    eventTitleFormated() {
      return this.propsEvent?.title
        ? this.propsEvent?.type
          ? this.$t(`enums.event.type.${this.propsEvent.type}`)
          : ''
        : this.$t('global.new_event') +
            (this.propsEvent?.type
              ? ' - ' + this.$t(`enums.event.type.${this.propsEvent.type}`)
              : '')
    },
    filteredAssets() {
      let tempModels = this.metadata?.events?.assets
      if (typeof this.propsEvent?.type !== 'undefined') {
        tempModels = tempModels?.filter((asset) => {
          return this.metadata?.events?.assets_type[
            this.propsEvent.type
          ]?.includes(asset.type)
        })
      }
      return tempModels
    }
  },
  methods: {
    ...mapMutations({
      alterEventByIndex: 'work/alterWorkEventAttributeByIndex',
      deleteWorkEventKeyByIndex: 'work/deleteWorkEventKeyByIndex'
    }),
    emitToDelete() {
      this.$emit('eventDeleteButtonPressed', this.index)
    },
    getInputValue({ attribute, value }) {
      if (attribute === 'type') {
        this.deleteWorkEventKeyByIndex({
          index: this.index,
          attribute: 'asset_id'
        })
      }
      this.alterEventByIndex({
        index: this.index,
        attribute: attribute,
        value: value
      })
    },
    afterWorkSelected(work) {
      this.propsEvent.work_id = work.id
    }
  }
}
</script>
